import { MongoObjectIdSchema } from '@terra/shared-utils';
import { z } from 'zod';

export const ReassociateHarEntriesExistingTargetSchema = z.object({
  kind: z.literal('existing'),
  endpointId: MongoObjectIdSchema,
});

export const ReassociateHarEntriesCreateItemSchema = z.object({
  harEntryId: MongoObjectIdSchema,
  path: z.string().min(1),
});

export const ReassociateHarEntriesCreateFromHarsTargetSchema = z
  .object({
    kind: z.literal('createFromHars'),
    path: z.string().min(1).optional(),
    items: z.array(ReassociateHarEntriesCreateItemSchema).min(1).optional(),
  })
  .superRefine((value, ctx) => {
    if (!value.path && !value.items) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'path or items is required',
        path: ['path'],
      });
    }
  });

export const ReassociateHarEntriesTargetSchema = z.discriminatedUnion('kind', [
  ReassociateHarEntriesExistingTargetSchema,
  ReassociateHarEntriesCreateFromHarsTargetSchema,
]);

export const ReassociateHarEntriesBodySchema = z.object({
  harEntryIds: z.array(MongoObjectIdSchema).min(1),
  target: ReassociateHarEntriesTargetSchema,
});

export const ReassociateHarEntriesCollisionSchema = z.object({
  collision: z.enum(['active', 'archived']),
  suggestedEndpointId: MongoObjectIdSchema,
  method: z.string(),
  host: z.string(),
  path: z.string(),
  message: z.string(),
});

export const ReassociateHarEntriesReturnSchema = z.object({
  sourceEndpointId: MongoObjectIdSchema,
  targetEndpointId: MongoObjectIdSchema,
  targetEndpointIds: z.array(MongoObjectIdSchema).optional(),
  movedHarEntryIds: z.array(MongoObjectIdSchema),
  remountedSignalIds: z.array(MongoObjectIdSchema),
  createdTarget: z.boolean(),
  sourceDeleted: z.boolean(),
});

export type ReassociateHarEntriesExistingTarget = z.infer<
  typeof ReassociateHarEntriesExistingTargetSchema
>;
export type ReassociateHarEntriesCreateItem = z.infer<
  typeof ReassociateHarEntriesCreateItemSchema
>;
export type ReassociateHarEntriesCreateFromHarsTarget = z.infer<
  typeof ReassociateHarEntriesCreateFromHarsTargetSchema
>;
export type ReassociateHarEntriesTarget = z.infer<
  typeof ReassociateHarEntriesTargetSchema
>;
export type ReassociateHarEntriesBody = z.infer<
  typeof ReassociateHarEntriesBodySchema
>;
export type ReassociateHarEntriesCollision = z.infer<
  typeof ReassociateHarEntriesCollisionSchema
>;
export type ReassociateHarEntriesReturn = z.infer<
  typeof ReassociateHarEntriesReturnSchema
>;
